'use strict';

const propTypes = require('prop-types');
const React = require( 'react' );
const { bool, string, oneOfType, arrayOf, node } = propTypes;
const createReactClass = require('create-react-class');

const SchemaTag = createReactClass({

  propTypes: {
    noSchemaMarkup: bool,
    tagType: string,
    children: oneOfType( [arrayOf(node), node] )
  },

  getDefaultProps() {
    return {
      noSchemaMarkup: false,
      tagType: 'span',
      children: null
    };
  },

  render( ) {
    const { noSchemaMarkup, tagType, children } = this.props;

    let stuffToRender = null;

    const CustomTag = `${tagType}`;

    let newProps = {};
    const excludeProps = [ 'noSchemaMarkup', 'tagType', 'children' ];

    Object.keys(this.props).map(( prop ) => {
      if ( excludeProps.indexOf(prop) === -1 && ( !noSchemaMarkup || prop.length < 4 || prop.substring(0, 4) !== 'item' ) ) {
        newProps[ prop ] = this.props[ prop ];
      }
    });

    if ( children !== null ) {
      stuffToRender = <CustomTag {...newProps}>{ children }</CustomTag>;
    } else {
      stuffToRender = <CustomTag {...newProps} />;
    }

    return ( stuffToRender );
  }
});

module.exports = SchemaTag;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/SchemaTag.jsx